import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.dev';
import { UserAdminDTO } from '../model/UserAdminDTO';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  endpoint = `${environment.apiURL}/admin`;

  constructor(private http:HttpClient) { }


  // Método para obtener todos los usuarios
  getAllUsers(): Observable<UserAdminDTO[]>{
    return this.http.get<UserAdminDTO[]>(`${this.endpoint}/users`, { withCredentials: true });
  }

  getUserById(id: string): Observable<UserAdminDTO> {
    return this.http.get<UserAdminDTO>(`${this.endpoint}/user/${id}`, { withCredentials: true });
  }

  getUserByUsername(username: string): Observable<UserAdminDTO> {
    return this.http.get<UserAdminDTO>(`${this.endpoint}/user/username/${username}`, { withCredentials: true });
  }

  getUserByEmail(email: string): Observable<UserAdminDTO> {
    return this.http.get<UserAdminDTO>(`${this.endpoint}/user/email/${email}`, { withCredentials: true });
  }

  updateUser(id: string, user: UserAdminDTO): Observable<UserAdminDTO> {
    return this.http.patch<UserAdminDTO>(`${this.endpoint}/user/update/${id}`, user, { withCredentials: true });
  }

  blockUser(id: string): Observable<UserAdminDTO> {
    return this.http.patch<UserAdminDTO>(`${this.endpoint}/user/block/${id}`, {}, { withCredentials: true });
  }

  unblockUser(id: string): Observable<UserAdminDTO> {
    return this.http.patch<UserAdminDTO>(`${this.endpoint}/user/unblock/${id}`, {}, { withCredentials: true });
  }

  disableUser(id: string): Observable<UserAdminDTO> {
    return this.http.patch<UserAdminDTO>(`${this.endpoint}/user/disable/${id}`, {}, { withCredentials: true });
  }

  enableUser(id: string): Observable<UserAdminDTO> {
    return this.http.patch<UserAdminDTO>(`${this.endpoint}/user/enable/${id}`, {}, { withCredentials: true });
  }

}
